import { useContext, useMemo } from 'preact/hooks';

import { AppContext } from '../../context/AppContext';
import { CountryPost, Country } from '../../../../types';

import CountryCombobox from './CountryCombobox';

export default function CountryFilter( { wpCountryPosts }: {wpCountryPosts: CountryPost[]} ) {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext;
	const { activeCountry } = filterState;

	const handleCountryChange = ( value: Country ) => {
		dispatch( { type: 'SET_ACTIVE_COUNTRY', payload: value } );
	};

	const countries = useMemo(
		() => {
			// Reduce wpCountryPosts to needed properties.
			// Aligns with Country type for activeCountry filtering.
			const posts = wpCountryPosts.map( ( post ) => ( {
				name: post.name,
				post_id: post.post_id,
			} ) );

			// Sort alphabetically for combobox display.
			posts.sort( ( a, b ) => {
				const nameA = a.name.toUpperCase();
				const nameB = b.name.toUpperCase();
				if ( nameA < nameB ) {
					return -1;
				}
				if ( nameA > nameB ) {
					return 1;
				}
				return 0;
			} );

			return posts;
		}, [ wpCountryPosts ]
	);

	return (
		<CountryCombobox
			countries={ countries }
			activeCountry={ activeCountry }
			handleCountryChange={ handleCountryChange }
		/>
	);
}
